module.exports = __webpack_public_path__ + "img/sarpamp.5f420f3e.png";